import { render } from "./Comparisson.vue?vue&type=template&id=58570e8d&scoped=true"
import script from "./Comparisson.vue?vue&type=script&lang=js"
export * from "./Comparisson.vue?vue&type=script&lang=js"

import "./Comparisson.vue?vue&type=style&index=0&id=58570e8d&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58570e8d"]])

export default __exports__